export default class {

    constructor(name) {
        this.name = name;
    }

    target(keyword) {
        return keyword + '.' + this.name;
    }

}